import React, { FC } from 'react';

import { Stack } from '@mui/system';
import { FormikProps } from 'formik';

import { AdminAllowanceNames, ServiceTypes } from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';

import { Constants } from '../../../../helpers/Constants';
import strings from '../../../../localization';
import CustomTextField from '../../../common/CustomTextField';

import styles from './styles';

const { priceSuffix, allowancePlaceholder } = Constants;
const { paidHourlyRate } = AdminAllowanceNames;
const isFullService = ServiceHandler.getService() === ServiceTypes.full;

interface IAllowanceAdminWorkshift {
  formik: FormikProps<any>;
  infoText?: string;
}

const AllowanceAdminWorkshift: FC<IAllowanceAdminWorkshift> = ({
  formik,
  infoText,
}) =>
  (
    <Stack>
      <CustomTextField
        label={
        strings.formatString(
          strings.hourlyRateFormat,
          strings.professional,
        ) as string
      }
        name={paidHourlyRate}
        formik={formik}
        placeholder={allowancePlaceholder}
        suffix={priceSuffix}
        customClass={styles.hourlyRate}
        id={paidHourlyRate}
        horizontal
      />
      {isFullService && (
      <CustomTextField
        label={strings.pharmacyHourlyRate}
        name="pharmacyHourlyRate"
        formik={formik}
        placeholder={allowancePlaceholder}
        suffix={priceSuffix}
        customClass={styles.hourlyRate}
        infoText={infoText}
        id="pharmacyHourlyRate"
        horizontal
      />
      )}
    </Stack>
  );

export default AllowanceAdminWorkshift;
